import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./index.css";

const Footer = () => {
  const theme = useSelector((state) => state.theme);
  const footerText =
    theme === "LIGHT" ? "footer-light-text" : "footer-dark-text";
  return (
    <>
      <hr
        style={{
          background:
            theme === "LIGHT"
              ? "rgba(0, 0, 0, 0.10)"
              : "rgba(255, 255, 255, 0.10)",
          width: "100vw",
          position: "relative",
          left: "calc((100% - 100vw) / 2)",
        }}
      />
      <footer className={`footer ${footerText}`}>
        <div>
          <h1 className="nav-logo">OMK</h1>
          <p
            className="footer-thanks"
            style={{
              color:
                theme === "LIGHT" ? "inherit" : "rgba(128, 128, 128, 0.50)",
            }}
          >
            Thanks for stopping by <span>ッ</span>
          </p>
          <p
            className="footer-copyrite"
            style={{
              color:
                theme === "LIGHT" ? "inherit" : "rgba(128, 128, 128, 0.50)",
            }}
          >
            © 2023 Om Kumbhare. All Rights Reserved.
          </p>
        </div>
        <section className="footer-primary">
          <div>
            <h3 style={{ color: theme === "LIGHT" ? "inherit" : "#ffffff" }}>
              Links
            </h3>
            <Link to="/about">
              <button type="button" className="footer-button">
                About
              </button>
            </Link>
            <Link to="/work">
              <button type="button" className="footer-button">
                Work
              </button>
            </Link>
            <Link to="/techstack">
              <button type="button" className="footer-button">
                Tech Stack
              </button>
            </Link>
            <Link to="/certificates">
              <button type="button" className="footer-button">
                Certificates
              </button>
            </Link>
            <Link to="/contact">
              <button type="button" className="footer-button">
                Contact
              </button>
            </Link>
          </div>
          <div>
            <h3 style={{ color: theme === "LIGHT" ? "inherit" : "#ffffff" }}>
              Elsewhere
            </h3>
            <a href="mailto:om.kumbhare29@gmail.com" target="blank">
              <button type="button" className="footer-button">
                Email
              </button>
            </a>
            <a
              href="https://www.linkedin.com/in/omkumbhare"
              target="blank"
              className="footer-button"
            >
              Linkedin
            </a>
            <a
              href="https://github.com/DEV-OMK"
              target="blank"
              className="footer-button"
            >
              Github
            </a>
            <a
              href="https://twitter.com/omkumbhare"
              target="blank"
              className="footer-button"
            >
              Twitter
            </a>
            <a
              href="https://discord.com/"
              target="blank"
              className="footer-button"
            >
              Discord
            </a>
          </div>
        </section>
      </footer>
    </>
  );
};

export default Footer;
